"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleSuccess = void 0;
var user_1 = require("../../../build-babel/user");
var ga_1 = require("../../../build-babel/analytics/ga/ga");
var msads_1 = require("../../../build-babel/analytics/msads/msads");
var session_1 = require("../../../build-babel/session");
var handleSuccess = function handleSuccess(response) {
  var idToken = response.idToken;
  (0, session_1.setSession)(idToken, window.location.href);
  // GA
  (0, ga_1.pushToDataLayer)(ga_1.GA_EVENTS.SUCCESSFUL_LOGIN);
  if ((0, user_1.isNewUser)(idToken)) {
    var userRole = (0, user_1.getUserRole)(idToken);
    var event = userRole ? Object.assign(Object.assign({}, ga_1.GA_EVENTS.SUCCESSFUL_ACCOUNT_CREATION), {
      eventVariant: userRole
    }) : ga_1.GA_EVENTS.SUCCESSFUL_ACCOUNT_CREATION;
    (0, ga_1.pushToDataLayer)(event);
    (0, msads_1.pushToUET)(msads_1.MS_ADS_EVENTS.SUCCESSFUL_ACCOUNT_CREATION);
  }
};
exports.handleSuccess = handleSuccess;
//# sourceMappingURL=success.js.map